/**
 * TODO:
 * - api error handling
 */
import * as actionTypes from './actionTypes';

const initialState = {
    // role: {
    //     id: null,
    //     name: "",
    //     system: {
    //         id: null,
    //         name: ""
    //     },
    //     groups:[]
    // },
    roles: [],
    systems: [
        {id:"wsrtnbtaer", name: "Active Directory", groups: []}, // all available groups in system?
        {id:"adfghaeghd", name: "Sugar CRM", groups: []}, // all available groups in system?
    ],
    loading: false,
    saving: false
}

const roles = (state = initialState, action) => {
    switch (action.type) {
        
        case actionTypes.GET_USER_ROLES:
            state = {
                ...state,
                loading: true
            }
            break;
         
        case actionTypes.GET_USER_ROLES_SUCCESS:
            state = {
                ...state,
                loading: false,
                roles: action.payload
            }
            break;

        case actionTypes.SAVE_USER_ROLE:
            state = {
                ...state,
                saving: true
            }
            break;

        case actionTypes.SAVE_USER_ROLE_SUCCESS:
            const roles = state.roles.map(r => r.id !== action.payload.id ? r : action.payload);
            state = {
                ...state,
                roles,
                saving: false
            }
            break;

        // case actionTypes.ADD_GROUP_TO_ROLE:
        //     state = { 
        //         ...state,
        //         role: {
        //             ...state.role,
        //             groups: action.payload
        //         }
        //     };
        //     break;

        // case actionTypes.REMOVE_GROUP_FROM_ROLE:
        //     state = { 
        //         ...state,
        //         role: {
        //             ...state.role,
        //             groups: action.payload
        //         }
        //     };
        //     break;
            
        // case actionTypes.DISCARD_ROLE_CHANGES:
        //     state = {
        //         ...state,
        //         role: { ...initialState.role }
        //     }
        //     break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default roles;